/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneVideoTeaser as ResolvedStandaloneVideoTeaser } from 'base/components/standalone/VideoTeaser';

export const VideoTeaser: typeof ResolvedStandaloneVideoTeaser = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneVideoTeaser {...props} />
        </ErrorBoundary>
    );
});

export type VideoTeaserProps = PropsFromComponent<typeof VideoTeaser>;

/** @deprecated Use slot architecture instead */
export const VideoTeaserWith = (extras: DynamicStandaloneExtras): typeof VideoTeaser => {
    return function VideoTeaser(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'VideoTeaser');
        return <ResolvedStandaloneVideoTeaser {...mergeProps({ options: { theme } }, props)} />;
    }
}